module.exports = __webpack_public_path__ + "img/submit-h.feb74e9d.png";